<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/craft/adjusting/record/customPage" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('zhuangtai')">
            <yi_dictionary_select :max="8" multiple :type="'CRAFT_ADJUSTING_RECORD_STATUS'" :ids.sync="yt.conditions.status"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentId"> </yi_data_select>
            <!--            <yi_cross_select multiple :component="'web_base_equipment_list'" :ids.sync="yt.conditions.equipmentId">
            </yi_cross_select>-->
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <yi_cross_select multiple :component="'web_base_mould_list'" :ids.sync="yt.conditions.mouldId">
            </yi_cross_select>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button v-if="utils.checkPower('web_process_distribution_adjusting_record_insert')" size="mini" @click="yt.showEditDialog('web_process_distribution_adjusting_record_insert', null, '1300px'); setDefaultValue()" type="primary">
          {{ $t('xinzeng') }}
        </el-button>
      </template>


      <template #invalidate_msg="scope">
        {{ $t(scope.row.invalidateMsg) }}
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <!-- 查看-->
            <el-button type="text" v-if="utils.checkPower('web_process_distribution_adjusting_record_get')" @click="yt.showEditDialog('web_process_distribution_adjusting_record_get', scope.row, '1300px')">
              {{ $t('chakan') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.sendCount > 0">
            <!-- 复制-->
            <el-button type="text" v-if="utils.checkPower('web_process_distribution_adjusting_record_insert')" @click="yt.showEditDialog('web_process_distribution_adjusting_record_copy', scope.row, '1300px')">
              {{ $t('fuzhi') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.status == '3' && scope.row.sendCount == 0">
            <!-- 下发 允许下发-->
            <el-button type="text" v-if="utils.checkPower('web_process_distribution_adjusting_record_send')" @click="yt.showEditDialog('web_process_distribution_adjusting_record_send', scope.row, '1300px')">
              {{ $t('web_process_distribution_adjusting_record_send') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.sendCount > 0">
            <!-- 下发记录 下发次数大于0-->
            <el-button type="text" v-if="utils.checkPower('web_process_distribution_adjusting_record_send_record')" @click="yt.showEditDialog('web_process_distribution_adjusting_record_send_record', scope.row, '1000px')">
              {{ $t('web_process_distribution_adjusting_record_send_record') }}
            </el-button>
          </el-col>
          <!--      作废    -->
          <el-col :span="0.1" v-if="scope.row.status == '1' || scope.row.status == '3'">
            <el-button v-if="utils.checkPower('web_process_distribution_adjusting_record_invalidate')" type="text" @click="invalidated(scope.row)">
              {{ $t('web_process_distribution_adjusting_record_invalidate') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog class="dialog" :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">

      <!-- 新增调机 -->
      <template v-if="yt.editObj.action == 'web_process_distribution_adjusting_record_insert'">
        <div>
          <add-adjusting ref="addAdjusting" @dialogClose="yt.isShowEditDialog = false; yt.get(1)" :formLabelWidth="yt.formLabelWidth"></add-adjusting>
        </div>
        <!--        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button size="mini" @click="save" :loading="yt.editObj.loading" type="primary">   {{ $t("baocun") }} </el-button>
        </span>-->
      </template>
      <!-- 查看 -->
      <template v-if="yt.editObj.action == 'web_process_distribution_adjusting_record_get'">
        <div>
          <see-adjusting ref="seeAdjustingRef" :isSend="false" @dialogClose="yt.isShowEditDialog = false; yt.get(1)" :formLabelWidth="yt.formLabelWidth" :id="yt.editObj.id"></see-adjusting>
        </div>
      </template>
      <!-- 下发 -->
      <template v-if="yt.editObj.action == 'web_process_distribution_adjusting_record_send'">
        <div>
          <see-adjusting ref="seeAdjustingRef" :isSend="true" @dialogClose="yt.isShowEditDialog = false; yt.get(1)" :formLabelWidth="yt.formLabelWidth" :id="yt.editObj.id"></see-adjusting>
        </div>
      </template>
      <!--查看下发记录      -->
      <template v-if="yt.editObj.action == 'web_process_distribution_adjusting_record_send_record'">
        <div class="dialog-scroller">
          <send-detail-list ref="sendDetailListRef" :formLabelWidth="yt.formLabelWidth" :row="yt.editObj"></send-detail-list>
        </div>
      </template>
      <!--复制      -->
      <template v-if="yt.editObj.action == 'web_process_distribution_adjusting_record_copy'">
        <div>
          <add-adjusting ref="addAdjusting" @dialogClose="yt.isShowEditDialog = false; yt.get(1)" :formLabelWidth="yt.formLabelWidth" :row="yt.editObj"></add-adjusting>
        </div>
      </template>


    </el-dialog>
  </div>
</template>

<script>

import addAdjusting from './add_adjusting.vue';
import seeAdjusting from './see_adjusting.vue'
import sendDetailList from './send_detail_list.vue';

export default {
  name: 'web_process_distribution_adjusting_record',
  components: {
    sendDetailList,
    addAdjusting, seeAdjusting
  },
  data() {
    return {
      simpleOrgId: '',
      refreshOneKey: 0,
      refreshTwoKey: 0,
      equipmentIds: '',
      indexKey: null, // 高亮显示
      columns: [
        {
          label: 'zhuangtai',
          prop: 'status',
          width: 75,
          type: 'dictionary_tag',
          key: 'CRAFT_ADJUSTING_RECORD_STATUS'

        },
        {
          label: 'craft_adjusting_record_adjusting_code',
          prop: 'adjustingCode',
          sort: 'string'

        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name',
          /* sort: 'string'*/
        },
        {
          label: 'mujumingcheng',
          prop: 'mould.name',
          /* sort: 'string'*/
        },
        /* {
           label: 'mujumingcheng',
           prop: 'model.name',
           sort: 'string'
         },*/

        {
          label: 'beizhu',
          prop: 'remark'
        },
        /*    {
              label: 'craft_adjusting_record_send_count',
              prop: 'sendCount',
              width: 80,
            },*/
        {
          label: 'issuedTime',
          prop: 'latestSendTime',
          type: 'time',
        },
        {
          label: 'craft_adjusting_record_laster_send_people',
          prop: 'lasterSendPeople'
        },
        /*   {
             label: 'zuofeiren',
             prop: 'invalidatePerson'
           },*/
        {
          label: 'invalidate_msg',
          type: 'slot',
        },
        /*  {
            label: 'zuofeishijian',
            prop: 'invalidateTime',
            type:'time',
          },*/
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }

      ],

    };
  },


  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime desc',
      };
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 保存上下限参数
    save() {
      this.yt.loading = true;
      this.$refs["set_upper_lower"].$refs["form"]
        .validate((valid) => {
          if (valid) {
            const params = this.$refs["set_upper_lower"].form;
            if (!params.datas || params.datas.length == 0) {
              return;
            }
            return this.http.post("/web/craft/threshold_configuration/batchInsert", params)
              .then((response) => {
                this.yt.isShowEditDialog = false;
                this.yt.get(1);
              }).catch((error) => {
                this.yt.editObj.loading = true;
                this.$message.error(error);
              });
          }
        }).finally(() => {
          this.yt.editObj.loading = false;
        });
    },

    invalidated(obj) {
      this.$prompt(this.$t('invalidate_msg'), this.$t('zuofei'), {
        confirmButtonText: this.$t('queding'),
        cancelButtonText: this.$t('quxiao'),
        inputValidator: (value) => {       // 点击按钮时，对文本框里面的值进行验证
          if (value == null || value == '') {
            return '必填';
          }
          if (value.length > 200) {
            return '输入长度不能超过200';
          }
        },
      }).then(({ value }) => {
        this.http.post('/web/craft/adjusting/record/invalidate', {
          id: obj.id,
          invalidateMsg: value,
        }).then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
        }).catch(msg => {
          this.utils.errorMessage(msg);
        });
      }).catch(() => {

      });

    },

    /*   handleSelectionChange(section, value) {
         let res = this.multipleSelection.filter(item => {
           return item.id == value.id;
         });
         if (res.length > 0) {
           this.multipleSelection = this.multipleSelection.filter(item => {
             return item.id != value.id;
           });
         } else {
           this.multipleSelection.push(value);
         }
       },*/
    // 关闭tag标签
    /*closeTag(id) {
      this.multipleSelection = this.multipleSelection.filter(item => {
        return item.id != id;
      });
      let ids = this.multipleSelection.map(item => {
        return item.id;
      });
      this.$nextTick(() => {
        this.tableData.forEach(row => {
          if (ids.indexOf(row.id) == -1) {
            this.$refs.table.toggleRowSelection(row, false);
          }
        });
      });
    },*/
    // 监听分页
    /*    handleCurrentChange(val) {
          this.pagination.currentPage = val;
        },*/


  }
};
</script>


<style scoped="scoped" lang="scss">
/deep/ .el-dialog .el-dialog__body {
  max-height: 100% !important;
  padding: 0 20px;
}
</style>
